import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * Track cart recipient address type event.
 *
 * @param {Object} payload
 * @param {string} payload.deliveryType - Delivery type (used with deliveryTypeDetail)
 * @param {string} [payload.deliveryTypeDetail] - Delivery type detail (used with deliveryType)
 * @returns {Promise<void>}
 *
 * @example
 * onTrackCartRecipientAddressType({
 *   deliveryType: 'home_delivery',
 *   deliveryTypeDetail: 'tw_tcat_frozen'
 * });
 */
export const onTrackCartRecipientAddressType = async ({
  deliveryType,
  deliveryTypeDetail,
}) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_RECIPIENT_ADDRESS_TYPE,
    data: {
      event_category: 'Cart',
      delivery_type: deliveryType,
      delivery_type_detail: deliveryTypeDetail,
    },
  });
};
